<template>
  <master-main
    :addProperties="{
      isWizard: false,
    }"
    :exportProperties="{
      pdf: {
        filename: `${$t('sowing.nurseries')}.pdf`,
        route: `${getModuleRoute}/pdf`,
      },
      xls: {
        filename: `${$t('sowing.nurseries')}.xlsx`,
        route: `${getModuleRoute}/excel`,
      },
    }"
    :route="getModuleRoute"
    :showProperties="showProperties"
    :tableProperties="tableProperties"
    @closeModal="handleCloseModal"
    @openModal="handleOpenModal"
    @refresh="refresh"
    @showHideLoading="showHideLoading"
    @showNotification="notifyVue"
    ref="masterMain"
  >
  <template slot="dialogForm">
      <edit-or-create-nursery 
      v-if="renderComponent"
      :syncDialog="modals"
      @addEdit="addEdit"
      @closeModal="handleCloseModal"
      @showHideLoading="showHideLoading"
      @showNotification="notifyVue"
      ref="editCreate"
      />
    </template>
  </master-main>
</template>
<script>
import EditCreate from 'src/views/Pages/Dashboard/Nursery/Nursery/EditCreate.vue';
import MasterMain from 'src/components/Layouts/Masters/MasterMain.vue';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinMain from 'src/mixins/master/mixin-main';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinRerender from 'src/mixins/mixin-rerender';
import MixinWithDialog from 'src/mixins/master/mixin-with-dialog';
import NurseriesTable from './nurseries-table';
export default {
  components: { MasterMain, [EditCreate.name]: EditCreate },
  data() {
    return {
      tableProperties: {},
      showProperties: { size: '70%' },
    };
  },
  mixins: [
    MixinAlert,
    MixinForm,
    MixinLoading,
    MixinMain,
    MixinPermissions,
    MixinRerender,
    MixinWithDialog,
  ],
  computed: {
    getModuleRoute() {
      return 'nursery/nursery';
    },
    buildTableProperties() {
      return {
        tableColumns: [...NurseriesTable().tableColumns],
        model: 'nursery',
        effectTags: 'dark',
        widthColumnStatus: 160,
        widthOperations: 110,
        defaultSort: { prop: 'code', order: 'ascending' },
      };
    },
  },
};
</script>
